import { userRolesEnums } from '@/config';
import { getTonnageValueFromKilograms, deepClone } from '@/services/helper.service';
class UnitCreationResponse {
  constructor(data) {
    data = data || {};
    this.urlGuid = data.urlGuid;
    this.imageApiUrl = data.imageApiUrl;
  }
}

class UnitCreation {
  constructor(data) {
    data = data || {};

    this.unitName = data.unitName;
    this.customerName = data.customerName;
    this.customerNr = data.customerNumber;
    this.languageCode = data.languageCode;
  }
}

class Unit {
  constructor(data) {
    data = data || {};

    this.address = data.address;
    this.created = data.created;
    this.customerLogo = data.customerLogo;
    this.customerName = data.customerName;
    this.unitName = data.unitName;
    this.edited = data.edited;
    this.geoLocation = data.geoLocation;
    this.languageCode = data.languageCode;
    this.myMillCode = data.myMillCode;
    this.name = data.name;
    this.timeZone = data.timeZone;
    this.unitContacts = data.unitContacts;
    this.unitPicture = data.unitPicture;
    this.urlGuid = data.urlGuid;
    this.usesMyMill = data.usesMyMill;
    this.specifications = data.specifications || [];
    this.machineGroups = data.machineGroups || [];
  }
}

class UnitData {
  constructor(data) {
    data = data || {};

    let generalInfo = data.generalInfo || {};

    this.urlGuid = generalInfo.urlGuid;
    this.name = generalInfo.name;
    this.customerName = generalInfo.customerName;
    this.customerLogo = generalInfo.customerLogo;
    this.customerNumber = generalInfo.customerNr;
    this.timeZone = generalInfo.timeZone;
    this.timeZoneOffsetInMinutes = generalInfo.timeZoneOffsetInMinutes;
    this.geoLocation = generalInfo.geoLocation;
    this.languageCode = generalInfo.languageCode;
    this.address = generalInfo.address;
    this.unitPicture = generalInfo.unitPicture;
    this.usesMyMill = generalInfo.usesMyMill;
    this.created = generalInfo.created;
    this.edited = generalInfo.edited;
    this.userRole = generalInfo.userRole;
    this.userIsAdminOrOwner = [userRolesEnums.admin, userRolesEnums.owner].includes(generalInfo.userRole);
    this.userIsObserver = [userRolesEnums.observer].includes(generalInfo.userRole);
    this.userIsMaintenance = [userRolesEnums.maintenance].includes(generalInfo.userRole);
    this.playPauseButtonInfo = generalInfo.playPauseButtonInfo || null;
    this.specifications = data.specificationData || [];
    this.machineGroups = data.machineGroupsData || [];
    this.unitContacts = data.unitContacts || [];
    this.unitUsers = data.unitUsers || [];
  }
}

class UnitOverview {
  constructor(data) {
    data = data || {};

    this.urlGuid = data.urlGuid;
    this.name = data.name;
    this.customerName = data.customerName;
    this.customerLogo = data.customerLogo;
    this.timeZoneOffsetInMinutes = data.timeZoneOffsetInMinutes;
    this.timeZone = data.timeZone;
    this.unitPicture = data.unitPicture;
    this.userRole = data.userRole;
    this.nextMaintenaceDate = data.nextMaintenaceDate;
    this.needsMaintenance = data.needsMaintenance;
    this.grindingWireCount = data.grindingWireCount;
    this.grindingCardCount = data.grindingCardCount;
    this.replacementWireCount = data.replacementWireCount;
    this.replacementCardCount = data.replacementCardCount;
    this.specifications = [];
    this.machineGroups = data.machineGroups || [];
  }
}

class UnitUpdate {
  constructor(data) {
    data = data || {};

    this.timeZoneIana = data.timeZone;
    this.geoLocation = data.geoLocation;
    this.address = data.address;
    this.unitNotificationReminder = {
      unitNotificationReminderUsesDays: false,
      unitNotificationReminderValue: 1
    };
    this.unitName = data.unitName;
    this.customerName = data.customerName;
    this.customerNr = data.customerNumber;
    this.languageCode = data.languageCode;
  }
}

class MachineGroup {
  constructor(data) {
    let { unitGuid, machineGroups } = data;
    let machinGroupsArray = machineGroups.map(group => {
      let machines = [];
      let easySetupMachines = [];
      if (group.cards.length > 0) {
        group.cards.forEach(machine => {
          if (machine.serialNumber && machine.comissionNumber) {
            let machineObject = deepClone(machine);
            machineObject.machineName = machineObject.cardName;
            delete machineObject.cardName;
            easySetupMachines.push(machineObject);
          } else {
            machines.push({ name: machine.cardName });
          }
        });
      }
      return { name: group.groupName, machines, easySetupMachines };
    });
    return { unitGuid, machineGroups: machinGroupsArray };
  }
}

class EasySetupToCards {
  constructor(data) {
    this.cards = [];
    data.forEach(delivery => {
      delivery.machines.forEach(machine => {
        this.cards.push({
          cardName: machine.machineSerialNumber,
          machineName: machine.machineSerialNumber,
          customerNumber: delivery.customerNumber,
          projectNumber: delivery.projectNumber,
          serialNumber: machine.machineSerialNumber,
          comissionNumber: machine.machineComissionNumber,
          machineTypeId: machine.machineTypeId
        });
      });
    });
  }
}

class ImportGroups {
  constructor(data) {
    this.groups = [];
    this.groups = data.map(group => {
      return new Group(group);
    });
  }
}

class UnitImport {
  constructor(data) {
    let { generalInfo, groups, contacts } = data;
    this.unitName = generalInfo.name;
    this.customerName = generalInfo.customerName;
    this.customerNumber = generalInfo.customerNr;
    this.address = generalInfo.address;
    this.geoLocation = generalInfo.geoLocation;
    let latLng = generalInfo.geoLocation.split(',');
    this.lat = latLng[0];
    this.lng = latLng[1];
    this.urlGuid = generalInfo.urlGuid;

    let importGroups = new ImportGroups(groups);
    this.groups = importGroups.groups;

    this.contacts = contacts;
    this.locationObject = {
      address: generalInfo.address,
      lat: latLng[0],
      lng: latLng[1]
    };
    this.imageUrl = generalInfo.customerLogo;
    this.unitPictureUrl = generalInfo.unitPicture;
  }
}

class Card {
  constructor(data) {
    this.cardName = data.name;
    this.urlGuid = data.urlGuid;
  }
}

class CardUpdate {
  constructor(data) {
    data = data || {};
    this.manufacturer = data.manufacturer;
    this.serialNumber = data.serialNumber;
    this.commissionNumber = data.commissionNumber;
    this.machineType = data.machineType;
  }
}

class CardNameUpdate {
  constructor(data) {
    data = data || {};
    this.name = data.machineName;
  }
}

class Group {
  constructor(data) {
    let cards = data.machines.map(machine => {
      return new Card(machine);
    });
    this.groupName = data.name;
    this.cards = cards;
    this.urlGuid = data.urlGuid;
  }
}

class MaintenanceWires {
  constructor(data, metric) {
    this.wires = [];

    data.machineWires.forEach(wireData => {
      if (wireData.wire && wireData.wire.id) {
        let wire = new MaintenanceWire(wireData, metric);
        this.wires.push(wire);
      }
    });
  }
}

class MaintenanceWire {
  constructor(data, metric) {
    this.dashboardPosition = data.dashboard;
    this.wirePositionId = data.wirePositionId;
    this.wirePositionTranslated = data.wirePositionTranslated;
    this.wireFeatures = data.wireFeatures;
    let wire = data.wire;
    if (wire) {
      this.canBeGrinded = wire.canBeGrinded;
      this.id = wire.id;
      this.initialTonnage = getTonnageValueFromKilograms(wire.kilograms, metric);
      this.tonnage = getTonnageValueFromKilograms(wire.kilograms, metric);
      this.lastGrinding = wire.lastGrinding;
      this.lastGrindingKilograms = wire.lastGrindingKilograms;
      this.lastReplacement = wire.lastReplacement;
      this.name = wire.name;
      this.recommendation = wire.recommendation;
      this.state = 0;
      this.wireState = wire.state; // use for maintenance to show the status bar
      this.backEndState = wire.state;
      this.oldWireId = wire.wdOemId;
      this.newWireId = null;
      this.newWireName = '';
      this.ignoreForTons = 0;
      this.ignoreForDays = 0;
      this.ignoreOption = 0;
    }
  }
}
export {
  UnitCreation,
  UnitCreationResponse,
  Unit,
  UnitData,
  UnitOverview,
  UnitUpdate,
  MachineGroup,
  EasySetupToCards,
  ImportGroups,
  UnitImport,
  Card,
  CardUpdate,
  CardNameUpdate,
  Group,
  MaintenanceWires,
  MaintenanceWire
};
